import { gql } from '../../../../../../hooks'

export const DELETE_CLIENTS_CASES = gql`
  mutation AdministrationDeleteClientClientsCases($id: ID!) {
    aDelete(path: "client/clients/cases", id: $id) {
    }
  }
`

export const LIST_CLIENTS_CASES = gql`
  query AdministrationListClientClientsCases(
    $page: Int
    $limit: Int
    $filter: JSONObject
  ) {
    aList(
      path: "client/clients/cases"
      filter: $filter
      page: $page
      limit: $limit
    ) {
      pagination {
        page
        limit
        number_of_pages
      }
    }
  }
`
